import { useTranslation } from 'react-i18next';
import type { IPiiFieldToggleProps } from './IPiiFieldToggleProps';

/**
 * «Персональні дані» під рядком власного поля простору (рішення 2 етапу 8, поза прототипом — Issue 042): прапорець `pii` власного поля
 * (ADR-023 customFields); позначене поле пояснює, хто бачить значення (privacy.md: власники й адміністратори простору, автор запису,
 * виконавець, якого призначив інший учасник; решта бачить «Приховано»), підказка — де діє приховування. Спроєктовані поля його не мають —
 * їхній прапорець задає опубліковане визначення.
 */
export function PiiFieldToggle({ label, checked, canEdit, onChange }: IPiiFieldToggleProps) {
  const { t } = useTranslation();
  return (
    <label className="rb-pii" title={t('rtBuilder.piiTip')}>
      <input type="checkbox" className="rb-check" checked={checked} disabled={!canEdit} aria-label={`${t('rtBuilder.pii')} · ${label}`}
        onChange={() => onChange(!checked)} />
      <span className="rb-pii__label">{t('rtBuilder.pii')}</span>
      {checked && <span className="rb-pii__hint">{t('rtBuilder.piiHint')}</span>}
    </label>
  );
}
